export default function initSentry () {
}
